module.exports = __webpack_public_path__ + "img/cx.172a41ec.svg";